<template>
    <div class="answer-box" id="answer-box">
        <!-- <title-nav v-if="$store.state.userAgent === 'Mobile'"/> -->
        <title-nav />
        <div class="content">
            <div v-for="(list,index) in lists" :key="index">
                <div class="title">{{ list.question }}</div>
                <div class="answer">{{ list.answer }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import TitleNav from '../../components/nav/TitleNav.vue'
const seo = require('../../../config/index')

export default {
  name: 'Answer',
  components: {
    TitleNav
  },
  mounted(){
    // if(this.$store.state.userAgent !== 'Mobile'){
    //     document.getElementById("answer-box").style.cssText= 'margin-top: 98px;height:100%';
    // }
  },
  data(){
      return {
        lists: seo.config.commonQA
      }
  },
  methods:{
    aboutUs(){

    }
  },
  props:{

  }
}
</script>

<style scoped lang="scss">
.answer-box {
    background: #fff;
    min-height: 100vh;
    box-sizing: border-box;
    .content {
        margin: 50px 10px 10px;
        padding: 10px 0 0;
        div {
            padding:5px 0;
        }
        .title {
            text-align: left;
            font-size: 18px;
        }
        .answer {
            text-align: left;
            color: rgba(0,0,0,0.5)
        }
    }
}
</style>
